export function initializeAnalytics() {
  const source = document.querySelector("#site-analytics-code");

  if (!(source instanceof HTMLTemplateElement)) {
    return;
  }

  const parsed = document.createElement("template");
  parsed.innerHTML = source.content.textContent ?? "";

  for (const script of parsed.content.querySelectorAll("script")) {
    const executable = document.createElement("script");

    for (const attribute of script.attributes) {
      executable.setAttribute(attribute.name, attribute.value);
    }
    executable.textContent = script.textContent;
    script.replaceWith(executable);
  }

  document.head.append(parsed.content);
  source.remove();
}
